/* Scrolling to a section.

   `scrollIntoView` is the obvious call and it is not reliable enough here: some
   engines ignore its smooth behaviour entirely, and none of them know about the
   sticky header, so the thing you asked to see ends up underneath it. The offset
   is computed instead. */

export function scrollToSection(id: string): void {
  const el = document.getElementById(id);
  if (!el) return;

  const header = document.querySelector('.app-header, .screen-head');
  const clearance = (header?.getBoundingClientRect().height ?? 0) + 10;
  const top = Math.max(0, el.getBoundingClientRect().top + window.scrollY - clearance);

  const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });

  // A few engines accept the call and do nothing. Land it either way.
  window.setTimeout(() => {
    if (Math.abs(window.scrollY - top) > 8) window.scrollTo(0, top);
  }, 400);
}
